// extracted by mini-css-extract-plugin
export var alertIcon = "_my-0";